var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row no-gutters mb-3" }, [
      _c("div", { staticClass: "col-12 mb-3" }, [
        _c("div", { staticClass: "mr-md-4 pb-3 rounded shadow-sm" }, [
          _c(
            "div",
            { staticClass: "col-head py-2 px-3 rounded-top text-white" },
            [_vm._v(_vm._s(_vm.getVideoName()))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-3 my-2", attrs: { id: "user_section" } },
            [
              _c(
                "video",
                { attrs: { width: "800", height: "600", controls: "" } },
                [
                  _c("source", {
                    attrs: { src: _vm.getVideoNamePath(), type: "video/mp4" }
                  }),
                  _vm._v(
                    "\n          Your browser does not support the video tag.\n          "
                  )
                ]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2 mb-4" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9919be88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9919be88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/VideoDetail.vue
// module id = null
// module chunks = 